type Handler<T> = (payload: T) => void;

export class EventBus<EventMap extends Record<string, unknown>> {
  private handlers = new Map<keyof EventMap, Set<Handler<unknown>>>();

  on<K extends keyof EventMap>(event: K, handler: Handler<EventMap[K]>): () => void {
    let set = this.handlers.get(event);
    if (!set) {
      set = new Set();
      this.handlers.set(event, set);
    }
    set.add(handler as Handler<unknown>);
    return () => {
      set?.delete(handler as Handler<unknown>);
    };
  }

  emit<K extends keyof EventMap>(event: K, payload: EventMap[K]): void {
    const set = this.handlers.get(event);
    if (!set) return;
    for (const h of set) (h as Handler<EventMap[K]>)(payload);
  }

  off<K extends keyof EventMap>(event: K): void {
    this.handlers.delete(event);
  }

  clear(): void {
    this.handlers.clear();
  }
}

export type EngineEvents = {
  "scene:enter": { name: string };
  "scene:exit": { name: string };
  "asset:loaded": { id: string };
  "input:action": { name: string; value: number };
  "viewport:resize": { width: number; height: number };
};
